import React from 'react';
import ReactDOM from 'react-dom/client';
import { CssBaseline } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import { StytchProvider } from '@stytch/react';
import { StytchUIClient } from '@stytch/vanilla-js';

import reportWebVitals from './reportWebVitals';
import App from './components/App';
import theme from './theme';

const root = ReactDOM.createRoot(document.getElementById('root'));
const stytch = new StytchUIClient(process.env.REACT_APP_STYTCH_PUBLIC_TOKEN);

root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <StytchProvider stytch={stytch}>
        <CssBaseline />
        <App />
      </StytchProvider>
    </ThemeProvider>
  </React.StrictMode>
);
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
